export default "__VITE_ASSET__u$Ire5KN__"